"use client";

import * as React from "react";
import { ChevronRight } from "lucide-react";
import { cn } from "../../lib/utils";

interface Breadcrumb {
  label: string;
  href?: string;
}

interface AdminHeaderProps {
  title: string;
  breadcrumbs?: Breadcrumb[];
  actions?: React.ReactNode;
  className?: string;
}

export function AdminHeader({
  title,
  breadcrumbs,
  actions,
  className,
}: AdminHeaderProps) {
  return (
    <header
      data-slot="admin-header"
      className={cn(
        "sticky top-0 z-10 flex h-14 items-center justify-between border-b bg-background px-6",
        className
      )}
    >
      <div className="flex items-center gap-2">
        {breadcrumbs && breadcrumbs.length > 0 ? (
          <nav aria-label="Breadcrumb" className="flex items-center gap-1.5">
            {breadcrumbs.map((crumb, index) => {
              const isLast = index === breadcrumbs.length - 1;
              return (
                <React.Fragment key={`${crumb.label}-${index}`}>
                  {index > 0 && (
                    <ChevronRight className="size-3.5 text-muted-foreground" />
                  )}
                  {isLast || !crumb.href ? (
                    <span
                      className={cn(
                        "text-sm",
                        isLast
                          ? "font-medium text-foreground"
                          : "text-muted-foreground"
                      )}
                    >
                      {crumb.label}
                    </span>
                  ) : (
                    <a
                      href={crumb.href}
                      className="text-sm text-muted-foreground transition-colors hover:text-foreground"
                    >
                      {crumb.label}
                    </a>
                  )}
                </React.Fragment>
              );
            })}
          </nav>
        ) : (
          <h1 className="text-sm font-medium">{title}</h1>
        )}
      </div>
      {actions && <div className="flex items-center gap-2">{actions}</div>}
    </header>
  );
}
